package org.lennycodes.gradematewebsite

object FirebaseService {
    private val config = js("""
    ({
         apiKey: "AIzaSyCElwCUH_vMnId80LGwcCSOScGkhkJSsoM",
  authDomain: "gradematewebsite.firebaseapp.com",
  projectId: "gradematewebsite",
  storageBucket: "gradematewebsite.firebasestorage.app",
  messagingSenderId: "339047429129",
  appId: "1:339047429129:web:c752b102572d4557f5b4d8",
  measurementId: "G-ZHZ7FVMBZ7"
    })
    """)

    val app = initializeApp(config)
    val auth = getAuth(app)
    val db = getFirestore(app)
    val storage = getStorage(app)

    /** Reads the JS `auth.currentUser` property. No external needed. */
    val currentUser: dynamic?
        get() = auth.currentUser
}

// Keep the old function name for compatibility
fun isUserLoggedIn(): Boolean = FirebaseService.auth.currentUser != null